export const listSubscriptionItems = `
   query listSubscriptionItems($subscriptionId: ID!, $filter: SubscriptionItemsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listSubscriptionItems(subscriptionId: $subscriptionId, filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              subscriptionId
              priceId
              price {
                id
                productId
                amount
                billingPeriod
              }
              quantity
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getProduct = `
   query getSubscriptionItem($id:ID!) {
       getSubscriptionItem(id:$id) {
        id
        subscriptionId
        priceId
        quantity
        createdByUsername
        created
        updated
       } 
}`;
